<template>
  <WTooltip :label="tooltip" position="right">
    <div class="menu">
      <div class="alert-icon" :class="{ button__active: isLoggedStaffOnCall }">
        <WIcon
          class="button"
          icon="icAlertRotatinLight"
          size="large"
          @click="toggleOnCall"
        />
      </div>
    </div>
  </WTooltip>
</template>

<script>
import { WIcon, WTooltip } from '@alice-health/wonderland-vue'
import { mapGetters } from 'vuex'

import { useOnCallService } from '@/modules/user'
import Logger, { EventName } from '@/wrappers/logger'

export default {
  components: { WIcon, WTooltip },
  inject: ['notify'],
  computed: {
    ...mapGetters('channel/staff', ['isLoggedStaffOnCall']),
    tooltip() {
      return `${
        this.isLoggedStaffOnCall ? 'Desligar' : 'Ligar'
      } visualização de chats`
    }
  },
  methods: {
    async toggleOnCall() {
      const onCallService = useOnCallService()
      await onCallService.toggleOnCall()

      if (this.isLoggedStaffOnCall) {
        this.notify({
          description: '🚨 Visualização de chats da triagem',
          duration: 3000
        })
      }

      Logger.addLog(EventName.USER_INTERACTION_MENU, {
        data: {
          context: this.isLoggedStaffOnCall ? 'ONCALL_ON' : 'ONCALL_OFF'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle {
  align-self: center;
  margin: 0 24px 0 auto;

  input {
    display: none !important;

    &:checked {
      & + .toggle__label {
        background: var(--sys-color-surface-background-brand);
      }

      & + .toggle__label .toggle__icon {
        fill: var(--sys-color-content-active);
        transform: translateX(22px);
      }
    }
  }

  &__icon {
    background: var(--sys-color-surface-background-light);
    border-radius: 50%;
    display: inline-block;
    padding: 4px;
    margin: 4px;
    fill: var(--sys-color-content-primary);
    transition: transform 0.2s linear;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);

    .icon {
      margin: 0;
    }
  }

  &__label {
    background: var(--sys-color-surface-background-dark);
    border-radius: 100px;
    cursor: pointer;
    display: block;
    width: 54px;
    height: 32px;
  }
}

.menu {
  height: 64px;
  width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-icon {
  cursor: pointer;
  border: 4px solid var(--gl-color-shades-gray-60);
  border-radius: 50%;
  width: 48px;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;

  &.button__active {
    border-color: var(--gl-color-shades-magenta-60);
    color: var(--icon-fill);
  }
}
</style>
